import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ExchangeRate from "../../pages/customer/ExchangeRate";
import ExchangeRateIframe from "../../pages/customer/ExchangeRateIframe";

function CustomerTheme() {
  const [isTrust, setIsTrust] = useState(false);
  useEffect(() => {
    const referrer = document.referrer;
    if (
      referrer &&
      referrer !== "" &&
      !referrer.includes("https://www.msc.com")
    ) {
    } else {
      setIsTrust(true);
    }
  }, []);
  return (
    <>
      {isTrust && (
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<ExchangeRate />}></Route>
            <Route path="/embedded" element={<ExchangeRateIframe />}></Route>
          </Routes>
        </BrowserRouter>
      )}
    </>
  );
}

export default CustomerTheme;
